import React, { useEffect, useState } from "react";
import { userPayoutList } from "../../../../utils/apis/payment";
import { useSelector } from "react-redux";
import ReactTable from "../../../ReactTable/ReactTable";
import moment from "moment";
import LoaderOverlay from "../../../../reusableComponents/Loader";

const WithdrawalHistory = () => {
  const idToken = useSelector((state) => state.auth.idToken);

  const [payoutListData, setPayoutListData] = useState([]);
  const [loading, setLoading] = useState(true);
  const selectedBrand = useSelector((state) => state.brand.selectedBrand);

  useEffect(() => {
    const fetchPayoutList = async () => {
      try {
        setLoading(true);
        const { data } = await userPayoutList(idToken, selectedBrand);
        setPayoutListData(data);
      } catch (error) {
        console.error("Error fetching payout list:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPayoutList();
  }, [idToken]);

  const columns = React.useMemo(
    () => [
      {
        Header: "Login Id",
        accessor: "login_id",
        Cell: ({ value }) => (value ? value : "-"),
      },
      {
        Header: "Payout Type",
        accessor: "payout_type",
        Cell: ({ value }) => {
          if (!value) return "-";
          if (value === "AFS") return "Affiliate Fees";
          if (value === "PFS") return "Performance Fees";
          return value;
        },
      },
      {
        Header: "Amount",
        accessor: "amount_requested",
        Cell: ({ value }) => (value ? value : "-"),
      },
      {
        Header: "Profit Split",
        accessor: "profit_split",
        Cell: ({ value }) => (value ? value : "-"),
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value }) =>
          value ? (
            <div className="status_wrapper">
              <p className={`status ${value === "approved" ? "status-passes" : value === "new" ? "status-new" : value === "rejected" ? "status-error" : ""}`}>{value}</p>
            </div>
          ) : (
            "-"
          ),
      },
      {
        Header: "Created at",
        accessor: "created_at",
        Cell: ({ value }) => {
          if (!value) {
            return <>-</>;
          }

          const formattedDate = moment(value).isValid() ? moment(value).format("DD-MMM-YYYY") : "Invalid Date";

          return <>{formattedDate}</>;
        },
      },
      {
        Header: "Payout Method",
        accessor: "method",
        Cell: ({ value }) => (value ? value : "-"),
      },
    ],
    [payoutListData],
  );
  const [currentPage, setCurrentPage] = useState(1);

  return (
    <div className="withdrawalHistory_container">
      {loading && <LoaderOverlay />}
      <ReactTable
        data={payoutListData || []}
        columns={columns}
        loading={loading}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    </div>
  );
};

export default WithdrawalHistory;
